declare global {
  interface Object {
    let<T, R>(this: T, block: (it: T) => R): R
  }
}

Object.defineProperty(Object.prototype, 'let', {
  value<T, R>(this: T, block: (arg: T) => R) {
    return block(this)
  },
  writable: true,
  configurable: true,
})

export {}
